export function truncate(str, maxlength, overflow) {
    if (maxlength === void 0) { maxlength = 45; }
    if (overflow === void 0) { overflow = '…'; }
    if (!str || typeof (str) !== 'string') {
        return str;
    }
    return str.length > maxlength ? str.slice(0, maxlength) + overflow : str;
}
